import CheckDetail from '../components/CheckDetail'
import React, { useEffect, useRef, useState } from 'react'
import ReactDom from 'react-dom'
import Events from '../../../@utils/events'
import { Modal, Spin } from 'antd'
import service from '../../../@services'

export default function useShowCheckDetail() {
  const MountDom = useRef(document.createElement('div'))
  const events = useRef(new Events())
  useEffect(() => {
    let _MountDom = MountDom.current
    document.body.appendChild(_MountDom)
    return () => {
      document.body.removeChild(_MountDom)
    }
  }, [])

  useEffect(() => {
    let _MountDom = MountDom.current
    ReactDom.render(<CheckDetailModal events={events.current} />, _MountDom)
    return () => {
      ReactDom.unmountComponentAtNode(_MountDom)
    }
  }, [])
  /**
   *
   * @param {盘点单号} checkNo
   * @param {modal组件props} modalProps
   */
  const showDetail = (checkNo, modalProps) => {
    events.current.emit('open', { checkNo, modalProps })
  }
  const close = () => {
    events.current.emit('close')
  }
  return {
    showDetail,
    close
  }
}

const CheckDetailModal = props => {
  const [$confirmLoading, set$confirmLoading] = useState(false)
  const [detail, setDetail] = useState({})
  const [$show, set$show] = useState(false)
  const [$modalProps, set$modalProps] = useState({})
  const [$onInit, set$onInit] = useState(false)

  useEffect(() => {
    const offOpen = props.events.on('open', _onOk => {
      open(_onOk)
    })
    const offClose = props.events.on('close', () => {
      close()
    })
    return () => {
      offOpen()
      offClose()
    }
  }, [props.events])
  const open = async ({ checkNo, modalProps }) => {
    set$modalProps(modalProps)
    set$show(true)
    set$onInit(true)
    try {
      const _detail = await service.inventory.getCheckSheetDeail(checkNo)
      set$onInit(false)
      _detail && setDetail(_detail)
    } catch (error) {
      set$onInit(false)
    }
  }
  const close = () => {
    set$confirmLoading(false)
    set$show(false)
  }
  return (
    <Modal
      visible={$show}
      width={1000}
      onCancel={close}
      footer={null}
      confirmLoading={$confirmLoading}
      onOk={close}
      {...$modalProps}>
      {$onInit ? (
        <Spin />
      ) : (
        React.createElement(CheckDetail, {
          detail: detail
        })
      )}
    </Modal>
  )
}
